import { useState, useEffect } from 'react';
import firebase from 'firebase/app';

/**
 * One Smart POS session's terminal flow history, live, in the order it
 * happened — tags/{tagId}/taps/{tapId}/terminalEvents (strike-payer #387).
 * Written server-side only; Strike-admin read (rules). Oldest first: a flow
 * reads top-down, unlike the device registry's newest-first audit view.
 *
 * Shape (house convention): [loading, events, error].
 */
export function useTapTerminalEvents(tagId, tapId, max = 100) {
    const [state, setState] = useState({ loading: true, events: [], error: null });

    useEffect(() => {
        if (!tagId || !tapId) { setState({ loading: false, events: [], error: null }); return undefined; }
        setState({ loading: true, events: [], error: null });
        return firebase.firestore()
            .collection('tags').doc(tagId)
            .collection('taps').doc(tapId)
            .collection('terminalEvents')
            .orderBy('at', 'asc')
            .limit(max)
            .onSnapshot(
                (snap) => setState({
                    loading: false,
                    events: snap.docs.map((doc) => ({ id: doc.id, ...doc.data() })),
                    error: null,
                }),
                (err) => {
                    console.warn('[useTapTerminalEvents] listen failed:', err && err.message);
                    setState({ loading: false, events: [], error: err.message || 'Could not load the terminal flow' });
                },
            );
    }, [tagId, tapId, max]);

    return [state.loading, state.events, state.error];
}

export default useTapTerminalEvents;
